import { Language } from '../ts/customTypes';
import { Pages } from '../ts/customTypes';

// Background

// Icons
import IconBenefits from '../icons/content/benefits.svg';

// Content Images
import processStepTeileidentifikation1Svg from '../content/es/process-parts-identification-step1.svg';
import processStepTeileidentifikation2Svg from '../content/es/process-parts-identification-step2.svg';
import processStepTeileidentifikation3Svg from '../content/es/process-parts-identification-step3.svg';
import processStepTeileidentifikation4Svg from '../content/es/process-parts-identification-step4.svg';

import processStepLagerergaenzung1Svg from '../content/es/process-storage-step1.svg';
import processStepLagerergaenzung2Svg from '../content/es/process-storage-step2.svg';
import processStepLagerergaenzung3Svg from '../content/es/process-storage-step3.svg';
import processStepLagerergaenzung4Svg from '../content/es/process-storage-step4.svg';

import contactImage from '../content/mail-contact.png';
import testimonial1 from '../content/testimonial1.jpg';
import testimonial2 from '../content/testimonial2.jpg';
import { IconBestellschnittstelle } from '../../lib/components/content/IconBestellschnittstelle';
import { IconKatalogschnittstelle } from '../../lib/components/content/IconKatalogschnittstelle';
import { IconVerfuegbarkeitsschnittstelle } from '../../lib/components/content/IconVerfuegbarkeitsschnittstelle';
import { IconNettopreisschnittstelle } from '../../lib/components/content/IconNettopreisschnittstelle';

import landingpageSmallImage1 from '../content/landingpage-img-1.webp';
import landingpageSmallImage2 from '../content/landingpage-img-2.webp';
import landingpageBigImage from '../content/image-landingpage-big.jpg';

import imageKatalogschnittstelle from '../content/image-katalogschnittstelle.jpg';
import imageBestellschnittstelle from '../content/image-bestellschnittstelle.jpg';
import imageNettopreisschnittstelle from '../content/image-nettopreisschnittstelle.jpg';
import imageVerfuegbarkeitsschnittstelle from '../content/image-verfuegbarkeitsschnittstelle.jpg';
import flag from '../flags/flag-es.svg';

export const es: Language = {
    id: 'ES',
    languageName: 'Español',
    flagUrl: flag,
    headerHeading: 'eProcurement',
    backToLandingPageLabel: 'Resumen',
    infolayer: {
        text: (
            <>
                <p>
                    Nos alegramos de que desee obtener más información sobre las interfaces de OMNIplus eProcurement.
                </p>
                <p>
                    El sitio web está optimizado para su visualización en un ordenador o una tableta. Lamentablemente, la visualización en su dispositivo móvil no es posible.
                </p>
                <p>
                    También puede abrir el contenido en otros dispositivos a través de la dirección web de esta página. Solo tiene que enviar la dirección de esta página a una tableta o a su ordenador. Haga clic en el siguiente enlace para copiar la dirección web en el portapapeles:
                </p>
            </>
        ),
        button: 'Copiar enlace al portapapeles',
    },
    [Pages.LANDINGPAGE]: {
        headline: 'Proceso de aprovisionamiento',
        headlineWidth: 500,
        buttonContact: 'Contacto',
        buttonTestimonials: 'Feedback de clientes',
        tooltips: {
            availability: 'Interfaz\nde disponibilidad',
            catalogue: 'Interfaz de catálogo',
            identification: 'Identificación de\nlas piezas',
            order: 'Interfaz de pedidos',
            price: 'Interfaz de\nprecios netos',
            storage: 'Disposición de recambios',
        },
        background: '',
        images: {
            leftUpper: landingpageSmallImage1,
            leftLower: landingpageSmallImage2,
            big: landingpageBigImage,
        },
    },
    testimonialsPage: {
        headline: 'Feedback de clientes',
        headlineWidth: 420,
        testimonials: [
            {
                name: 'Jens-Uwe Mentel',
                imageUrl: testimonial1,
                job: 'Empleado técnico en Usedomer Bäderbahn GmbH',
                quotes: [
                    '«La configuración de la nueva interfaz de COSware ha funcionado bien. Como resultado, ahora podemos introducir y pedir piezas de recambio en el sistema de forma más rápida».',
                ],
            },
            {
                name: 'Mirano Bitici',
                job: 'Jefe del departamento de Compras de Stuttgarter Straßenbahnen AG',
                quotes: [
                    '«En muy poco tiempo se puso en marcha un proyecto para integrar nuestro sistema de compras con OMNIplus».',
                    '«Se debe destacar el modo de proceder pragmático y orientado a objetivos».',
                    '«Hoy en día, nos beneficiamos de la reducción de los costes de adquisición en el departamento de Compras y en nuestros talleres».',
                ],
            },
            {
                name: 'Richard Schallmoser',
                imageUrl: testimonial2,
                job: 'Compras en Holding Graz - Kommunale Dienstleistungen GmbH',
                quotes: [
                    '«Con la implantación, también hemos optimizado el proceso de adquisición en el entorno. Este beneficio colateral fue tan significativo para nosotros como las propias interfaces».',
                    '«En muy poco tiempo, la conexión ha tenido tanto éxito que es imposible imaginar la vida sin ella».',
                ],
            },
        ],
        footer: {
            headline: 'Nuestras interfaces se utilizan en:',
            companies: [
                'Stuttgarter Straßenbahnen AG',
                'Holding Graz – Kommunale Dienstleistungen GmbH',
                'Regionalbus Leipzig GmbH',
                'Usedomer Bäderbahn GmbH',
                'EBS Public Transportation B. V.',
            ],
        },
    },
    contactPage: {
        headline: 'Contacto',
        headlineWidth: 250,
        texts: [
            'La implementación de interfaces de eProcurement se centra en sus procesos, por eso le apoyamos en su proyecto de conexión individual para digitalizar su adquisición.',
            'Póngase en contacto con nosotros: ',
        ],
        email: 'omniplus-eprocurement@daimlertruck.com',
        imageUrl: contactImage,
        stepsHeadline: 'Por lo general, todo proyecto de conexión se desarrolla en cuatro pasos:',
        steps: ['Preparación', 'Concepción', 'Implementación', 'Puesta en marcha'],
        text: (
            <p>
                Tras ponerse en contacto con nosotros, en la fase de preparación, analizaremos cómo eProcurement puede
                ayudarle en su proceso de adquisición de piezas. A continuación, en la fase de concepción se analiza
                cómo y con qué coste puede realizarse la implementación. Tras una fase de pruebas, se implementa el
                nuevo proceso de adquisición.
            </p>
        ),
    },
    infoPages: {
        [Pages.VERFUEGBARKEITSSCHNITTSTELLE]: {
            headline: 'Interfaz de disponibilidad',
            icon: <IconVerfuegbarkeitsschnittstelle />,
            intro: 'Consulta de la disponibilidad de sus recambios a través de la interfaz directamente en el sistema del cliente.',
            text: (
                <p>
                    A través de la interfaz puede consultar las cantidades disponibles para los recambios que necesita. No solo se puede ver la disponibilidad de su punto de servicio OMNIplus, sino también en toda la cadena de suministro.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Ventajas para usted',
                    list: [
                        'Transparencia total sobre las cantidades de suministro disponibles en su punto de servicio OMNIplus',
                        'Indicación de la disponibilidad en toda la cadena logística',
                        'Mejor planificación del proceso de aprovisionamiento',
                        'Acceso a través de una interfaz API REST',
                    ],
                },
            ],
            images: {
                main: imageVerfuegbarkeitsschnittstelle,
            },
        },
        [Pages.BESTELLSCHNITTSTELLE]: {
            headline: 'Interfaz de pedidos',
            icon: <IconBestellschnittstelle />,
            intro: 'Enviar pedidos directamente a OMNIplus.',
            text: (
                <p>
                    La integración de una interfaz de pedido permite transmitir pedidos directamente al sistema de
                    OMNIplus. De este modo, al realizar el pedido en el sistema del cliente no se produce ninguna
                    interrupción del sistema y se suprime la transmisión manual de los contenidos del pedido, para que
                    el pedido se procese de forma más rápida y exacta. La conexión a través de una interfaz se puede
                    establecer actualmente con los centros de servicio propios de Daimler Buses con clasificación
                    BusWorld.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Ventajas para usted',
                    list: [
                        'Adquisición digital de recambios sin necesidad de cambiar de sistema',
                        'Proceso más rápido del pedido gracias a la creación directa de pedidos en Daimler Buses Service Center',
                        'Es posible transmitir una confirmación de pedido a través de la interfaz',
                        'Variedad de conexiones: conexión posible a través de estándares EDI, cXML o una interfaz API REST',
                    ],
                },
            ],
            images: {
                main: imageBestellschnittstelle,
            },
        },
        [Pages.KATALOGSCHNITTSTELLE]: {
            headline: 'Interfaz de catálogo',
            icon: <IconKatalogschnittstelle />,
            intro: 'Fácil identificación de los recambios necesarios sin salir del sistema del cliente.',
            text: (
                <p>
                    A través de una interfaz de catálogo se pueden identificar recambios en la OMNIplus eShop y
                    transferirlos al sistema del cliente. En el catálogo OMNIplus eShop se pueden ver los precios, así
                    como la disponibilidad en su punto de servicio OMNIplus.
                </p>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Ventajas para usted',
                    list: [
                        'Integración del parque móvil específico del operador en la OMNIplus eShop',
                        'Disponibilidades y precios personalizados',
                        'Cuatro posibilidades diferentes para la búsqueda de recambios, por ejemplo, mediante la documentación del vehículo en el catálogo BusParts Catalog',
                        'Compatibilidad con los estándares OCI y cXML',
                    ],
                },
            ],
            images: {
                main: imageKatalogschnittstelle,
            },
        },
        [Pages.NETTOPREISSCHNITTSTELLE]: {
            headline: 'Interfaz de precios netos',
            icon: <IconNettopreisschnittstelle />,
            intro: 'Consulte los precios de sus recambios específicos directamente en su sistema a través de la interfaz.',
            text: (
                <>
                    <p>
                        A través de la interfaz de precios netos puede transferir los precios de sus recambios
                        directamente desde el sistema de OMNIplus a su sistema de cliente. Para ello se tienen en cuenta
                        las condiciones y promociones especiales específicas de cada cliente. Puede consultar los
                        precios en todos los centros de servicio propios de Daimler Buses con clasificación BusWorld.
                    </p>
                </>
            ),
            infoBoxes: [
                {
                    icon: IconBenefits,
                    headline: 'Ventajas para usted',
                    list: [
                        'Indicación del precio teniendo en cuenta sus condiciones individuales',
                        'Transparencia total de los precios, incluso con precios especiales y descuentos por volumen',
                        'El proceso completo de pedido y autorización en el sistema del cliente',
                        'Acceso a través de una interfaz API REST',
                    ],
                },
            ],
            images: {
                main: imageNettopreisschnittstelle,
            },
        },
    },
    processPages: {
        [Pages.TEILEIDENTIFIKATION]: {
            headline: 'Identificación de piezas a través de la interfaz del catálogo',
            headlineWidth: 820,
            infoBox: {
                headline: 'Aplicación',
                bullets: [
                    '¿Está buscando un recambio para su vehículo, pero no conoce el código de la pieza que desea pedir? Por ejemplo, porque se trata de un nuevo modelo de vehículo o porque el recambio necesario no está guardado en su base de datos.',
                ],
            },
            steps: [
                {
                    imageUrl: processStepTeileidentifikation1Svg,
                    headline: 'Acceso al catálogo OMNIplus eShop',
                    content: (
                        <>
                            Dentro del sistema de gestión propio del cliente, se puede acceder al catálogo OMNIplus
                            eShop para iniciar la identificación de recambios.
                        </>
                    ),
                },
                {
                    imageUrl: processStepTeileidentifikation2Svg,
                    headline: 'Identificación de piezas a través de la OMNIplus eShop',
                    content: (
                        <>
                            En la interfaz de la eShop, hay cuatro posibilidades diferentes para identificar el recambio
                            necesario. Además de la integración de la flota, la eShop también ofrece, por ejemplo, la
                            búsqueda de piezas de recambio a través de la documentación del vehículo en el Catálogo
                            BusParts.
                        </>
                    ),
                },
                {
                    imageUrl: processStepTeileidentifikation3Svg,
                    headline: 'Transferencia al sistema del cliente',
                    content:
                        'Tras identificar las piezas de recambio necesarias y compilar el contenido de la cesta de la compra, la información sobre las piezas puede transferirse de la tienda electrónica OMNIplus al sistema del cliente.',
                },
                {
                    imageUrl: processStepTeileidentifikation4Svg,
                    headline: 'Pedido desde el sistema del cliente',
                    content: (
                        <>
                            A través de la interfaz de pedidos, su pedido se transmite con un solo clic al sistema
                            OMNIplus y puede procesarse directamente.
                        </>
                    ),
                },
            ],
        },
        [Pages.LAGERERGAENZUNG]: {
            headline: 'Disposición de recambios mediante la interfaz de disponibilidad y precios',
            headlineWidth: 1050,
            infoBox: {
                headline: 'Aplicación',
                bullets: [
                    'En muchos casos, ya se sabe qué recambios necesita.',
                    'Esto ocurre, por ejemplo, cuando la identificación de la pieza de repuesto se realiza en el taller y se crea una orden de compra en su sistema con los números de pieza necesarios.',
                    'O recibe una notificación en su sistema de gestión de que el stock mínimo de algunas piezas se ha alcanzado. Puede proceder a realizar un reabastecimiento de inventario.',
                ],
            },
            steps: [
                {
                    imageUrl: processStepLagerergaenzung1Svg,
                    headline: 'Disposición de los recambios que se quieren adquirir', // #AB1-Disposition-eProcurement-Click-Explainer#
                    content:
                        'En su sistema de gestión de mercancías, usted planifica los recambios necesarios en una orden de pedido, por ejemplo, para reponer existencias.',
                },
                {
                    imageUrl: processStepLagerergaenzung2Svg,
                    headline: 'Consulta de disponibilidad y precio',
                    content: (
                        <>
                            Tras crear una orden de compra en su sistema de clientes con las piezas de recambio a
                            adquirir, puede consultar las disponibilidades y precios asociados a través de la interfaz
                            de eProcurement.
                        </>
                    ),
                },
                {
                    imageUrl: processStepLagerergaenzung3Svg,
                    headline: 'Comprobar la orden de pedido',
                    content:
                        'En su sistema el operador puede visualizar la información solicitada sobre los recambios planificados y, dado el caso, iniciar sus procesos internos de autorización.',
                },
                {
                    imageUrl: processStepLagerergaenzung4Svg,
                    headline: 'Pedido desde el sistema del cliente',
                    content:
                        'A continuación, puede transmitir su pedido al sistema OMNIplus a través de la interfaz de pedido para que se pueda procesar directamente.',
                },
            ],
        },
    },
};
